// src/components/admin/ServicesManagement.jsx
import React, { useState, useEffect } from "react";
import api from "../../../services/httpService";
import "./ServiceSections.css";

const ServicesManagement = () => {
  // Hero Section State
  const [heroData, setHeroData] = useState(null);
  const [isHeroLoading, setIsHeroLoading] = useState(true);
  const [isHeroSaving, setIsHeroSaving] = useState(false);
  const [heroMessage, setHeroMessage] = useState("");
  const [isHeroEditing, setIsHeroEditing] = useState(false);

  const [heroImageFile, setHeroImageFile] = useState(null);
  const [heroImagePreview, setHeroImagePreview] = useState(null);

  // Homepage Section State
  // const [homepageData, setHomepageData] = useState(null);
  // const [isHomepageLoading, setIsHomepageLoading] = useState(true);
  // const [isHomepageSaving, setIsHomepageSaving] = useState(false);
  // const [homepageMessage, setHomepageMessage] = useState("");
  // const [isHomepageEditing, setIsHomepageEditing] = useState(false);

  // Services List State
  const [services, setServices] = useState([]);
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  const [servicesMessage, setServicesMessage] = useState("");

  // Form State
  const [activeForm, setActiveForm] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
    ImageKey: "",
  });
  const [isSaving, setIsSaving] = useState(false);
 
  const [serviceImageFile, setServiceImageFile] = useState(null);
  const [serviceImagePreview, setServiceImagePreview] = useState(null);

  useEffect(() => {
    fetchHeroData();
    //fetchHomepageData();
    fetchServices();
  }, []);

  // ==================== HERO SECTION ====================
  const fetchHeroData = async () => {
    setIsHeroLoading(true);
    try {
      const response = await api.get("/sentinix/services");
      if (response.data.success && Array.isArray(response.data.data)) {
        const heroList = response.data.data.filter(
          (item) => item.type === "hero" && !item.isDeleted
        );
        if (heroList.length > 0) {
          const latestHero = heroList[0];
          setHeroData({
            id: latestHero.id,
            type: latestHero.type,
            name: latestHero.name || "",
            description: latestHero.description || "",
            ImageKey: latestHero.ImageKey || "",
          });
        } else {
          setHeroData(null);
        }
      }
    } catch (error) {
      console.error("Error fetching hero:", error);
      setHeroData(null);
    } finally {
      setIsHeroLoading(false);
    }
  };

  const handleHeroImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setHeroImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setHeroImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveHero = async () => {
    if (!heroData?.name?.trim() || !heroData?.description?.trim()) {
      setHeroMessage("Title and Description are required");
      setTimeout(() => setHeroMessage(""), 3000);
      return;
    }

    setIsHeroSaving(true);
    setHeroMessage("");

    try {
      const formDataPayload = new FormData();
      formDataPayload.append("type", "hero");
      formDataPayload.append("name", heroData.name);
      formDataPayload.append("description", heroData.description);

      if (heroImageFile) {
        formDataPayload.append("ImageKey", heroImageFile);
      } else if (heroData.ImageKey) {
        formDataPayload.append("ImageKey", heroData.ImageKey);
      }

      let response;
      if (heroData?.id) {
        response = await api.put(
          `/sentinix/services/${heroData.id}`,
          formDataPayload,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      } else {
        response = await api.post(
          "/sentinix/services",
          formDataPayload,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      }

      if (response.data.success) {
        setHeroMessage("Hero section updated successfully!");
        setIsHeroEditing(false);
        setHeroImageFile(null);   
        setHeroImagePreview(null);
        fetchHeroData();          
      } else {
        setHeroMessage(response.data.error || "Failed to save hero section.");
      }
    } catch (error) {
      console.error("Error saving hero data:", error);
      setHeroMessage(
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Error saving hero data"
      );
    } finally {
      setIsHeroSaving(false);
      setTimeout(() => setHeroMessage(""), 3000);
    }
  };

  // ==================== HOMEPAGE SECTION ====================
  // const fetchHomepageData = async () => {
  //   setIsHomepageLoading(true);
  //   try {
  //     const response = await api.get("/sentinix/services");
  //     if (response.data.success && Array.isArray(response.data.data)) {
  //       const homepageList = response.data.data.filter(
  //         (item) => item.type === "homepage" && !item.isDeleted
  //       );
  //       if (homepageList.length > 0) {
  //         const latestHomepage = homepageList[0];
  //         setHomepageData({
  //           id: latestHomepage.id,
  //           type: latestHomepage.type,
  //           name: latestHomepage.name || "",
  //           description: latestHomepage.description || "",
  //         });
  //       } else {
  //         setHomepageData(null);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching homepage:", error);
  //     setHomepageData(null);
  //   } finally {
  //     setIsHomepageLoading(false);
  //   }
  // };

  // const handleSaveHomepage = async () => {
  //   if (!homepageData?.name?.trim() || !homepageData?.description?.trim()) {
  //     setHomepageMessage("Title and Description are required");
  //     setTimeout(() => setHomepageMessage(""), 3000);
  //     return;
  //   }

  //   setIsHomepageSaving(true);
  //   setHomepageMessage("");

  //   try {
  //     const payload = {
  //       type: "homepage",
  //       name: homepageData.name,
  //       description: homepageData.description,
  //     };

  //     let response;
  //     if (homepageData?.id) {
  //       response = await api.put(
  //         `/sentinix/services/${homepageData.id}`,
  //         payload
  //       );
  //     } else {
  //       response = await api.post("/sentinix/services", payload);
  //     }

  //     if (response.data.success) {
  //       setHomepageMessage("Homepage section updated successfully!");
  //       setIsHomepageEditing(false);
  //       fetchHomepageData();
  //     } else {
  //       setHomepageMessage(
  //         response.data.error || "Failed to save homepage section."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error saving homepage data:", error);
  //     setHomepageMessage(
  //       error.response?.data?.message ||
  //       error.response?.data?.error ||
  //       "Error saving homepage data"
  //     );
  //   } finally {
  //     setIsHomepageSaving(false);
  //     setTimeout(() => setHomepageMessage(""), 3000);
  //   }
  // };

  // ==================== SERVICES LIST ====================
  const fetchServices = async () => {
    setIsServicesLoading(true);
    try {
      const response = await api.get("/sentinix/services");
      if (response.data.success) {
        const filteredServices = (response.data.data || []).filter(
          (service) => service.type === "service"
        );
        setServices(filteredServices);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setIsServicesLoading(false);
    }
  };

  const handleServiceImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setServiceImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setServiceImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // ==================== FORM HANDLERS ====================
  const openAddForm = () => {
    setActiveForm("add");
    setFormData({ id: "", name: "", description: "", ImageKey: "" });
    setServiceImageFile(null);
    setServiceImagePreview(null);
    setServicesMessage("");
  };

  const openEditForm = (service) => {
    setActiveForm("edit");
    setFormData({
      id: service.id,
      name: service.name,
      description: service.description,
      ImageKey: service.ImageKey || "",
    });
    setServiceImageFile(null);
    setServiceImagePreview(null);
    setServicesMessage("");
  };

  const closeForm = () => {
    setActiveForm(null);
    setFormData({ id: "", name: "", description: "", ImageKey: "" });
    setServiceImageFile(null);
    setServiceImagePreview(null);
    setServicesMessage("");
  };

  const handleSaveService = async () => {
    if (!formData.name.trim() || !formData.description.trim()) {
      setServicesMessage("Name and Description are required");
      setTimeout(() => setServicesMessage(""), 3000);
      return;
    }

    setIsSaving(true);
    setServicesMessage("");

    try {
      const formDataPayload = new FormData();
      formDataPayload.append("type", "service");
      formDataPayload.append("name", formData.name);
      formDataPayload.append("description", formData.description);

      if (serviceImageFile) {
        
        formDataPayload.append("ImageKey", serviceImageFile);
      } else if (formData.ImageKey) {
        formDataPayload.append("ImageKey", formData.ImageKey);
      }

      let response;
      if (activeForm === "edit" && formData.id) {
        response = await api.put(
          `/sentinix/services/${formData.id}`,
          formDataPayload,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      } else {
        response = await api.post(
          "/sentinix/services",
          formDataPayload,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      }

      if (response.data.success) {
        setServicesMessage(
          activeForm === "edit"
            ? "Service updated successfully!"
            : "Service created successfully!"
        );
        fetchServices();
        setTimeout(() => closeForm(), 1500);
      } else {
        setServicesMessage(response.data.error || "Failed to save.");
      }
    } catch (error) {
      console.error("Error saving service:", error);
      setServicesMessage(
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Error saving data"
      );
    } finally {
      setIsSaving(false);
      setTimeout(() => setServicesMessage(""), 3000);
    }
  };

  const handleDeleteService = async (id) => {
    if (!window.confirm("Are you sure you want to delete this service?")) return;

    try {
      const response = await api.delete(`/sentinix/services/${id}`);
      if (response.data.success) {
        setServicesMessage("Service deleted successfully");
        fetchServices();
      } else {
        setServicesMessage(response.data.error || "Failed to delete service");
      }
    } catch (error) {
      console.error("Error deleting service:", error);
      setServicesMessage(
        error.response?.data?.error || "Error deleting service"
      );
    } finally {
      setTimeout(() => setServicesMessage(""), 3000);
    }
  };

  return (
    <div className="services-page-container">

      {/* ==================== ADD / EDIT MODAL ==================== */}
      {activeForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>
                {activeForm === "add" ? "Add New Service" : "Edit Service"}
              </h2>
              <button onClick={closeForm} className="modal-close-btn">
                ✕
              </button>
            </div>

            <div className="modal-body">
              {servicesMessage && (
                <div
                  className={`alert ${
                    servicesMessage.includes("success")
                      ? "alert-success"
                      : "alert-error"
                  }`}
                >
                  {servicesMessage}
                </div>
              )}

              {/* Service Name */}
              <div className="form-group">
                <label className="form-label">
                  Service Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  placeholder="Enter service name"
                  className="form-input"
                />
              </div>

              {/* Service Image */}
              <div className="form-group">
                <label className="form-label">Service Image</label>

                {/* ✅ Show new preview OR existing Cloudinary image */}
                {(serviceImagePreview || formData.ImageKey) && (
                  <div className="image-preview-box">
                    <img
                      src={serviceImagePreview || formData.ImageKey}
                      alt="Service"
                      className="preview-image"
                    />
                  </div>
                )}

                <div className="image-upload-section">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleServiceImageSelect}
                    className="file-input"
                  />
                  {/* ✅ No separate Upload button — image uploads on Save */}
                  {serviceImageFile && (
                    <p className="image-note">
                      ✅ {serviceImageFile.name} — will upload on Save
                    </p>
                  )}
                  {!serviceImageFile && formData.ImageKey && (
                    <p className="image-note">
                      ℹ️ No new image selected — existing image will be kept
                    </p>
                  )}
                </div>
              </div>

              {/* Description */}
              <div className="form-group">
                <label className="form-label">
                  Description <span className="required">*</span>
                </label>
                <textarea
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  rows={6}
                  placeholder="Enter detailed description of the service..."
                  className="form-textarea"
                />
              </div>
            </div>

            <div className="modal-footer">
              <button onClick={closeForm} className="btn-cancel">
                Cancel
              </button>
              <button
                onClick={handleSaveService}
                disabled={isSaving}
                className="btn-save"
              >
                {isSaving ? (
                  <>
                    <span className="spinner-small"></span>
                    Saving...
                  </>
                ) : (
                  <>{activeForm === "edit" ? "Update Service" : "Save Service"}</>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Page Header */}
      <div className="page-main-header">
        <h1 className="main-page-title">Services Management</h1>
        <p className="main-page-subtitle">
          Manage service hero section and individual services
        </p>
      </div>

      {/* ==================== SERVICE HERO SECTION ==================== */}
      <div className="section-box">
        <div className="section-box-header">
          <div>
            <h2 className="section-box-title">Service Hero Section</h2>
          </div>
          <button
            onClick={() => {
              setIsHeroEditing(!isHeroEditing);
              if (isHeroEditing) {
                setHeroImageFile(null);
                setHeroImagePreview(null);
              }
            }}
            className={isHeroEditing ? "btn-cancel-edit" : "btn-edit-section"}
          >
            {isHeroEditing ? "❌ Cancel" : "✏️ Edit"}
          </button>
        </div>

        {isHeroLoading ? (
          <div className="loading-state">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="section-box-content">
            {/* Title */}
            <div className="form-group">
              <label className="form-label">
                Title <span className="required">*</span>
              </label>
              <input
                type="text"
                value={heroData?.name || ""}
                onChange={(e) =>
                  setHeroData((prev) =>
                    prev
                      ? { ...prev, name: e.target.value }
                      : {
                          type: "hero",
                          name: e.target.value,
                          description: "",
                          ImageKey: "",
                        }
                  )
                }
                readOnly={!isHeroEditing}
                placeholder="Enter services page title"
                className={`form-input ${
                  !isHeroEditing ? "readonly-input" : ""
                }`}
              />
            </div>

            {/* Image */}
            <div className="form-group">
              <label className="form-label">Image</label>

              {/* ✅ Show new preview OR existing Cloudinary image */}
              {(heroImagePreview || heroData?.ImageKey) && (
                <div className="image-preview-box">
                  <img
                    src={heroImagePreview || heroData?.ImageKey}
                    alt="Hero"
                    className="preview-image"
                  />
                </div>
              )}

              {isHeroEditing && (
                <div className="image-upload-section">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleHeroImageSelect}
                    className="file-input"
                  />
                  {/* ✅ No separate Upload button — image uploads on Save */}
                  {heroImageFile && (
                    <p className="image-note">
                      ✅ {heroImageFile.name} — will upload on Save
                    </p>
                  )}
                  {!heroImageFile && heroData?.ImageKey && (
                    <p className="image-note">
                      ℹ️ No new image selected — existing image will be kept
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Description */}
            <div className="form-group">
              <label className="form-label">
                Description <span className="required">*</span>
              </label>
              <textarea
                value={heroData?.description || ""}
                onChange={(e) =>
                  setHeroData((prev) =>
                    prev
                      ? { ...prev, description: e.target.value }
                      : {
                          type: "hero",
                          name: "",
                          description: e.target.value,
                          ImageKey: "",
                        }
                  )
                }
                readOnly={!isHeroEditing}
                rows={4}
                placeholder="Enter services page description"
                className={`form-textarea ${
                  !isHeroEditing ? "readonly-input" : ""
                }`}
              />
            </div>

            {isHeroEditing && (
              <div className="section-save-area">
                <button
                  onClick={handleSaveHero}
                  disabled={isHeroSaving}
                  className="btn-save-section"
                >
                  {isHeroSaving ? (
                    <>
                      <span className="spinner-small"></span>
                      Saving...
                    </>
                  ) : (
                    <>💾 Update Hero Section</>
                  )}
                </button>
                {heroMessage && (
                  <span
                    className={`message-inline ${
                      heroMessage.includes("success")
                        ? "success-message"
                        : "error-message"
                    }`}
                  >
                    {heroMessage}
                  </span>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* ==================== HOMEPAGE SECTION ==================== */}
      {/* <div className="section-box">
        <div className="section-box-header">
          <div>
            <h2 className="section-box-title">Homepage Section</h2>
          </div>
          <button
            onClick={() => setIsHomepageEditing(!isHomepageEditing)}
            className={
              isHomepageEditing ? "btn-cancel-edit" : "btn-edit-section"
            }
          >
            {isHomepageEditing ? "❌ Cancel" : "✏️ Edit"}
          </button>
        </div>

        {isHomepageLoading ? (
          <div className="loading-state">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="section-box-content">
            {/* Title */}
            {/* <div className="form-group">
              <label className="form-label">
                Title <span className="required">*</span>
              </label>
              <input
                type="text"
                value={homepageData?.name || ""}
                onChange={(e) =>
                  setHomepageData((prev) =>
                    prev
                      ? { ...prev, name: e.target.value }
                      : {
                          type: "homepage",
                          name: e.target.value,
                          description: "",
                        }
                  )
                }
                readOnly={!isHomepageEditing}
                placeholder="Enter homepage title"
                className={`form-input ${
                  !isHomepageEditing ? "readonly-input" : ""
                }`}
              />
            </div> */}

            {/* Description */}
            {/* <div className="form-group">
              <label className="form-label">
                Description <span className="required">*</span>
              </label>
              <textarea
                value={homepageData?.description || ""}
                onChange={(e) =>
                  setHomepageData((prev) =>
                    prev
                      ? { ...prev, description: e.target.value }
                      : {
                          type: "homepage",
                          name: "",
                          description: e.target.value,
                        }
                  )
                }
                readOnly={!isHomepageEditing}
                rows={4}
                placeholder="Enter homepage description"
                className={`form-textarea ${
                  !isHomepageEditing ? "readonly-input" : ""
                }`}
              />
            </div> */}

            {/* {isHomepageEditing && (
              <div className="section-save-area">
                <button
                  onClick={handleSaveHomepage}
                  disabled={isHomepageSaving}
                  className="btn-save-section"
                >
                  {isHomepageSaving ? (
                    <>
                      <span className="spinner-small"></span>
                      Saving...
                    </>
                  ) : (
                    <>💾 Update Homepage Section</>
                  )}
                </button>
                {homepageMessage && (
                  <span
                    className={`message-inline ${
                      homepageMessage.includes("success")
                        ? "success-message"
                        : "error-message"
                    }`}
                  >
                    {homepageMessage}
                  </span>
                )}
              </div>
            )} */}
          {/* </div>
        )}
      </div> */} 

      {/* ==================== SERVICES SECTION ==================== */}
      <div className="section-box">
        <div className="section-box-header">
          <div>
            <h2 className="section-box-title">Services</h2>
          </div>
          <button onClick={openAddForm} className="btn-add-new">
            + Add New Service
          </button>
        </div>

        <div className="services-grid-wrapper">
          {isServicesLoading ? (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Loading services...</p>
            </div>
          ) : services.length === 0 ? (
            <div className="empty-state">
              <p>No services yet</p>
              <button onClick={openAddForm} className="btn-add-first">
                + Add Your First Service
              </button>
            </div>
          ) : (
            <div className="services-grid">
              {services.map((service) => (
                <div key={service.id} className="service-card">
                  <div className="service-image-wrapper">
                    {service?.ImageKey ? (
                      <img src={service.ImageKey} alt={service.name} />
                    ) : (
                      <div className="no-image-placeholder">
                        <span>No Image</span>
                      </div>
                    )}
                  </div>

                  <div className="service-info">
                    <h3 className="service-title">{service.name}</h3>
                    <p className="service-desc">{service.description}</p>
                  </div>

                  <div className="service-actions">
                    <button
                      onClick={() => openEditForm(service)}
                      className="btn-edit"
                    >
                      ✏️ Edit
                    </button>
                    <button
                      onClick={() => handleDeleteService(service.id)}
                      className="btn-delete"
                    >
                      🗑️ Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServicesManagement;
